import React from 'react'
import './style.css'
const index = () => {

    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }

  return (
    <div className="component-desc">
            <h2 className="heading">Input</h2>
            <div className="description">Inputs are necessary for user interaction with the website. Inputs are used to take information from the user.</div>
            <div className="divider"></div>
            <h4 className="heading">Normal Input</h4>
            <div style={{alignSelf:'center'}} className="input-container">
            <input 
                type="text" 
                class="input" 
                placeholder="Enter domain name here..."
            />
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&width=680&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cinput%2520%250A%2509type%253D%2522text%2522%2520%250A%2509class%253D%2522input%2522%2520%250A%2509placeholder%253D%2522Enter%2520domain%2520name%2520here...%2522%250A%252F%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>

            <div className="divider"></div>
            <h4 className="heading">Input Group</h4>
            <div style={{marginTop:'3rem',alignSelf:'center'}} className="input-container">
                <div class="input-group">
                    <input 
                    type="text" 
                    class="input" 
                    placeholder="Search for products..."
                    />
                    <button class="btn btn--primary">Search</button>
                </div>
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&width=680&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522input-group%2522%253E%250A%2509%253Cinput%2520%250A%2509%2509type%253D%2522text%2522%2520%250A%2509%2509class%253D%2522input%2522%2520%250A%2509%2509placeholder%253D%2522Search%2520for%2520products...%2522%250A%2509%252F%253E%250A%2509%253Cbutton%2520class%253D%2522btn%2520btn--primary%2522%253ESearch%253C%252Fbutton%253E%250A%253C%252Fdiv%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
        </div>
  )
}

export default index